import { computed, watch } from 'vue';

export function useAddressStateSelector(form, options = {}) {
    const resetFields = options.resetFields ?? ['city', 'state', 'zip'];
    const emptyValue = options.emptyValue ?? null;

    const showStateDropdown = computed(() => !form.value.country || ['US', 'CA'].includes(form.value.country));

    const onStatePicked = (newState) => {
        if (newState && !form.value.country) {
            form.value.country = 'US';
        }
    };

    watch(
        () => form.value.country,
        (newCountry, oldCountry) => {
            // Auto-fill from a state pick (null → 'US') must not blow away the picked state.
            if (!oldCountry && newCountry === 'US') {
                return;
            }
            for (const field of resetFields) {
                form.value[field] = emptyValue;
            }
        }
    );

    return { showStateDropdown, onStatePicked };
}
